export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20warm%20amber%20and%20dark%20charcoal%20tones%2C%20minimalist%20pattern%20with%20flowing%20lines%2C%20modern%20digital%20aesthetic%2C%20soft%20gradient%20with%20dot%20matrix%20texture%2C%20elegant%20dark%20background%20with%20golden%20highlights%2C%20technology%20network%20node%20visualization%20in%20warm%20colors%2C%20cinematic%20atmosphere&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="黑料网永久域名 - 官方最新入口背景"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-3xl mx-auto">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-500/20 border border-primary-500/30 rounded-full mb-6">
          <span className="w-2 h-2 bg-accent-400 rounded-full animate-pulse"></span>
          <span className="text-xs md:text-sm text-background-50/90 font-medium">官方认证 · 持续更新 · 永久有效</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
          黑料网<strong className="text-primary-400">永久域名</strong>
        </h1>

        <p className="text-sm md:text-base text-background-50/75 max-w-xl mx-auto mb-8 leading-relaxed">
          黑料网永久域名是用户稳定访问黑料网的核心入口。本页汇总最新、最全的黑料网永久域名地址，确保您随时畅通访问，不再因域名更换而迷失。<strong>收藏本页即可永久使用最新域名直达。</strong>
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#domain-list"
            className="px-7 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-links-line mr-2"></i>查看最新域名
          </a>
          <a
            href="#faq"
            className="px-7 py-3 bg-background-50/15 text-background-50 font-medium rounded-md hover:bg-background-50/25 border border-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            了解更多
          </a>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-primary-400">12+</p>
            <p className="text-xs text-background-50/60 mt-1">可用域名</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-accent-400">99.9%</p>
            <p className="text-xs text-background-50/60 mt-1">在线率</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">24h</p>
            <p className="text-xs text-background-50/60 mt-1">每日更新</p>
          </div>
        </div>
      </div>
    </section>
  );
}